"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const authorization_service_1 = require("../authorization/authorization.service");
const jwt_1 = require("@nestjs/jwt");
const bcrypt = tslib_1.__importStar(require("bcryptjs"));
const user_entity_1 = require("../users/user.entity");
let AuthService = class AuthService {
    constructor(userRepo, jwtService, authorizationService) {
        this.userRepo = userRepo;
        this.jwtService = jwtService;
        this.authorizationService = authorizationService;
    }
    async validateUser(email, password) {
        const user = await this.userRepo
            .createQueryBuilder('u')
            .addSelect('u.passwordHash')
            .where('u.email = :email AND u.isActive = true', { email })
            .getOne();
        if (!user)
            return null;
        const match = await bcrypt.compare(password, user.passwordHash);
        if (!match)
            return null;
        await this.userRepo.update(user.id, { lastLoginAt: new Date() });
        return user;
    }
    async login(email, password) {
        const user = await this.validateUser(email, password);
        if (!user)
            throw new common_1.UnauthorizedException('Invalid credentials');
        const permissions = await this.authorizationService.getPermissionsForRole(user.role);
        const payload = { sub: user.id, email: user.email, role: user.role };
        return {
            accessToken: this.jwtService.sign(payload),
            user: {
                id: user.id,
                name: user.name,
                email: user.email,
                role: user.role,
                permissions,
            },
        };
    }
    async hashPassword(plain) {
        return bcrypt.hash(plain, 10);
    }
};
exports.AuthService = AuthService;
exports.AuthService = AuthService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(user_entity_1.User)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof jwt_1.JwtService !== "undefined" && jwt_1.JwtService) === "function" ? _b : Object, typeof (_c = typeof authorization_service_1.AuthorizationService !== "undefined" && authorization_service_1.AuthorizationService) === "function" ? _c : Object])
], AuthService);
